import { render, staticRenderFns } from "./emailMessaging.vue?vue&type=template&id=48e2ec58&scoped=true&"
import script from "./emailMessaging.vue?vue&type=script&lang=js&"
export * from "./emailMessaging.vue?vue&type=script&lang=js&"
import style0 from "./emailMessaging.vue?vue&type=style&index=0&id=48e2ec58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e2ec58",
  null
  
)

export default component.exports